import { useTranslation } from 'react-i18next';

import FieldTextarea from '@/components/common/Field/FieldTextarea/Field';
import Textarea from '@/components/common/Input/Textarea/Textarea';
import { privacyText } from '@/constants/terms';

import * as S from './style';

const PrivacyTerms = () => {
	const { t } = useTranslation();

	return (
		<S.Container>
			<S.Title>{t('mypage.privacyTerms.title')}</S.Title>
			<FieldTextarea title="mypage.privacyTerms.title">
				<Textarea value={t(privacyText)} />
			</FieldTextarea>
		</S.Container>
	);
};

export default PrivacyTerms;
